import axios from "axios";
import store from "@/store/store";
import {authService} from '@/modules/auth/services/authService.js'

const HTTP = axios.create({
  baseURL: process.env.VUE_APP_RT_MESSAGING_APP_URL,
  withCredentials: false
});
const DEFAULT_POLLING_TIMEOUT = 30000

let cancelTokenSource

const fetchLatestUpdateTime = (params) => {
  cancelTokenSource = axios.CancelToken.source();
  return HTTP.post('messaging', params, {
    cancelToken: cancelTokenSource.token,
    timeout: DEFAULT_POLLING_TIMEOUT
  })
    .then(res => res.data)
};

const cancelRequest = () => {
  if (cancelTokenSource) {
    cancelTokenSource.cancel('cancel');
  }
}

HTTP.interceptors.request.use(
  config => {
    // Do something before request is sent
    const token = store.getters["auth/token"];
    config.headers["x-mobile-app"] = store.getters["isMobileApp"];
    config.headers["x-app-name"] = "Frontage";
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

HTTP.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    // Do something with response error
    if (error.response && error.response.status === 401) {
      let resp = await authService.getToken()
      if (resp.success){
        store.commit('auth/saveToken',resp.jwt)
        error.config.headers["Authorization"] = `Bearer ${resp.jwt}`;
        return HTTP(error.config);
      } else {
        authService.logout();
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  }
);

export default {
  fetchLatestUpdateTime,
  cancelRequest,
};
